// The configuration API sends some amounts as strings ("1.0"). Not CurrencyHelper.fromString:
// that turns 0 into null, which would read as a margin the backend withheld.
const toNumber = (value) => {
  if (value == null || value === '') return null
  return typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value
}

export const toLedgerRow = ({ label, sub, code, price }) => ({
  label,
  sub,
  code,
  buy: toNumber(price?.PurchaseExcl),
  sell: toNumber(price?.Excl),
  margin: toNumber(price?.MarginExcl),
  pct: toNumber(price?.MarginPercentage),
})

// A margin the backend withheld stays absent in the total instead of counting as zero.
const sumOrNull = (rows, field) =>
  rows.some((row) => row[field] == null) ? null : rows.reduce((sum, row) => sum + row[field], 0)

// Against the absolute sale, so on a negative sale (a correction) the sign still follows the margin.
const marginPercentage = (margin, sell) => {
  if (margin == null || !sell) return null
  return Math.round((margin / Math.abs(sell)) * 10000) / 100
}

export const ledgerTotal = (rows) => {
  const sell = sumOrNull(rows, 'sell')
  const margin = sumOrNull(rows, 'margin')
  return { buy: sumOrNull(rows, 'buy'), sell, margin, pct: marginPercentage(margin, sell) }
}

const configurationChoices = (configuration) => [
  { label: '/Vcr/Autoline/Color Label', item: configuration.Color },
  { label: '/Vcr/Autoline/Rim Label', item: configuration.Rim },
  { label: '/Vcr/Autoline/Upholstery Label', item: configuration.Interior?.Upholstery },
  { label: '/Vcr/Autoline/Upholstery Color Label', item: configuration.Interior?.UpholsteryColor },
]

export const configurationRows = (configuration, translate) => {
  if (!configuration) return []
  const baseCar = toLedgerRow({
    label: configuration.CatalogCarName,
    price: configuration.NetCatalogPrice,
  })
  const choices = configurationChoices(configuration)
    .filter(({ item }) => item?.Name)
    .map(({ label, item }) =>
      toLedgerRow({
        label: translate(label),
        sub: item.Name,
        code: item.ShortId,
        price: item.Price,
      })
    )
  const features = (configuration.Categories || [])
    .flatMap((category) => category.Features || [])
    .map((feature) =>
      toLedgerRow({ label: feature.Name, code: feature.ShortId, price: feature.Price })
    )
  return [baseCar, ...choices, ...features]
}

export const quoteItemRows = (items, codeField = 'ID') =>
  (items || []).map((item) =>
    toLedgerRow({ label: item.Name, code: item[codeField], price: item.Price })
  )
